export default "__VITE_ASSET__98993ca0__"